import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = { teamId: Number }
  static targets = [
    "teamMembersCount",
    "projectsCount",
    "activeCrawlsCount",
    "openIssuesCount"
  ]

  connect() {
    this.subscribe()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  subscribe() {
    const consumer = createConsumer()
    this.subscription = consumer.subscriptions.create(
      { channel: "DashboardChannel", team_id: this.teamIdValue },
      {
        received: (data) => {
          this.updateMetrics(data)
        }
      }
    )
  }

  updateMetrics(data) {
    if (data.team_members_count !== undefined) {
      this.teamMembersCountTarget.textContent = data.team_members_count
    }
    if (data.projects_count !== undefined) {
      this.projectsCountTarget.textContent = data.projects_count
    }
    if (data.active_crawls_count !== undefined) {
      this.activeCrawlsCountTarget.textContent = data.active_crawls_count
    }
    if (data.open_issues_count !== undefined) {
      this.openIssuesCountTarget.textContent = data.open_issues_count
    }
  }
}

